"use client";

import { c as _c } from "react/compiler-runtime";
import type { Entry, UnresolvedLink } from "contentful";
import { isEntry } from "@/lib/contentful/guards";
import { usePriceLabels } from "@/queries/usePriceLabels";
import type { TypeProductSkeleton } from "@/types/contentful/generated";
import { stripZeroWidth } from "@/utils/ContentfulHelper";
import { RelatedProductCard } from "./RelatedProductCard";
type ProductEntry = Entry<TypeProductSkeleton, undefined, string>;
type ItemBlock = ProductEntry | UnresolvedLink<"Entry">;
interface Props {
  header: string;
  items: ItemBlock[];
  isShortDescriptionIncluded?: boolean;
  isPriceIncluded?: boolean;
}
export default function RelatedProductsClient(t0) {
  const $ = _c(10);
  const {
    header,
    items,
    isShortDescriptionIncluded,
    isPriceIncluded
  } = t0;
  const products = items.filter(_temp);
  const skus = isPriceIncluded ? products.map(_temp2) : [];
  const {
    data: priceLabels
  } = usePriceLabels(skus, isPriceIncluded);
  if (products.length === 0) {
    return null;
  }
  const t1 = "flex flex-col gap-6 py-6 w-full max-w-site-content mx-auto px-6";
  let t2;
  if ($[0] !== header) {
    t2 = <h2 className="heading-lg">{header}</h2>;
    $[0] = header;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = "flex flex-col gap-6 rounded-md bg-card shadow-sm md:flex-row";
  let t4;
  if ($[2] !== isShortDescriptionIncluded || $[3] !== priceLabels) {
    t4 = product => <RelatedProductCard key={product.sys.id} title={product.fields.title} slug={(product.fields.productPage as {
      fields: {
        slug: string;
      };
    }).fields.slug} sku={product.fields.sku} images={product.fields.images} shortDescription={product.fields.shortDescription} isShortDescriptionIncluded={isShortDescriptionIncluded} priceLabel={priceLabels?.[product.fields.sku] ?? undefined} />;
    $[2] = isShortDescriptionIncluded;
    $[3] = priceLabels;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = products.map(t4);
  let t6;
  if ($[5] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t6) {
    t7 = <section className={t1}>{t2}{t6}</section>;
    $[7] = t2;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}
function _temp2(p) {
  return stripZeroWidth(p.fields.sku);
}
function _temp(item) {
  return isEntry(item);
}